import type { Messenger } from '@plug-core/interfaces/messenger'

// Use the same global singleton as plug-core messenger
declare global {
  var __globalWebMessenger: Messenger | undefined
}

export const initializeMessenger = ({ connect }: { connect: string } = { connect: 'popup' }): Messenger => {
  console.log('[Core Messenger] Initializing for connection:', connect, '- using global singleton')
  
  if (!globalThis.__globalWebMessenger) {
    throw new Error('[Core Messenger] Global messenger not initialized! Make sure plug-core messenger is loaded first.')
  }
  
  return globalThis.__globalWebMessenger
}